import createGetFormSyncWarnings from './selectors/getFormSyncWarnings';
import plain from './structure/plain';
export default createGetFormSyncWarnings(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/getFormSyncWarnings.js
// module id = ceMC
// module chunks = 1